<template>
    <div id="contenedor-listado-fuentes-financieras-mobiles">
        <template
            v-for="(fuenteFinanciera, index) in listadoFuentesFinancieras">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ fuenteFinanciera.nombre }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :fuenteFinanciera="fuenteFinanciera">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    {{ fuenteFinanciera.origen }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoFuentesFinancierasMobiles',
  props: {
    listadoFuentesFinancieras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
